import { Contract } from "src/api-service";
import { AppError } from "../../app-store-error.types";

// **************************************************************************
// CONTRACT STATE
// **************************************************************************

export interface ContractState {
    contract: Contract | null;
    contracts: Contract[];
    // List UI state
    loaded: boolean;
    searchFilter: string;
    startDateFrom: Date | null;
    startDateTo: Date | null;
    endDateFrom: Date | null;
    endDateTo: Date | null;
    // Loading
    loadingList: boolean;
    loadingDetail: boolean;
    savingDetail: boolean;
    deletingDetail: boolean;
    loadingSections: boolean;
    savingSections: boolean;
    deletingSections: boolean;
    uploadingFiles: boolean;
    deletingFiles: boolean;
    loadingReminders: boolean;
    savingReminders: boolean;
    deletingReminders: boolean;
    // Error
    error: AppError | null;
}

export const initialContractState: ContractState = {
    contract: null,
    contracts: [],
    // List UI state
    loaded: false,
    searchFilter: "",
    startDateFrom: null,
    startDateTo: null,
    endDateFrom: null,
    endDateTo: null,
    // Loading
    loadingList: false,
    loadingDetail: false,
    savingDetail: false,
    deletingDetail: false,
    loadingSections: false,
    savingSections: false,
    deletingSections: false,
    uploadingFiles: false,
    deletingFiles: false,
    loadingReminders: false,
    savingReminders: false,
    deletingReminders: false,
    // Error
    error: null,
};



